import { Tooltip } from "by/gamefactory/cityversetycoon/scenes/common/components/Tooltip";
import { Container, Sprite, Text, TextStyle } from "pixi.js";
import { UpgradeResourcePackage } from "../../resources/UpgradeResourcePackage";
import { GameFont } from "by/gamefactory/cityversetycoon/scenes/common/GameFont";

export class UpgradeTutorialForTokenTooltip extends Container {
    private static readonly DESCRIPTION_TEXT = 'REMINDER: YOU CAN USE YOUR\nOWN POINTS TO PURCHASE\nBUILDING UPGRADES';
    private tooltip: Tooltip;
    private tokenImage: Sprite;
    private descriptionText: Text;

    private readonly upgradeResources: UpgradeResourcePackage;

    public constructor(upgradeResources: UpgradeResourcePackage) {
        super();
        this.upgradeResources = upgradeResources;
        this.build();
        this.layout();
    }

    private build(): void {
        this.tooltip = new Tooltip(this.upgradeResources.assets_views_upgrade_token_tutorial_token_tooltip_png, 526, 241);
        this.tokenImage = new Sprite(this.upgradeResources.assets_views_upgrade_token_tutorial_token_png);
        this.descriptionText = new Text(UpgradeTutorialForTokenTooltip.DESCRIPTION_TEXT, new DescriptionTextStyle());
        this.addChild(this.tooltip, this.tokenImage, this.descriptionText);
    }

    private layout(): void {
        this.tokenImage.position.set(35, 63);
        this.descriptionText.position.set(161, 64);
    }
}

class DescriptionTextStyle extends TextStyle {
    public constructor() {
        super({
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 34,
            fill: 'FFFFFF',
            lineHeight: 40
        });
    }
}